import LogoLink from './LogoLink';
import type { LogoLinkProps } from './LogoLink';

export default LogoLink;
export type { LogoLinkProps };
